// Telemetría de funnel — wrapper de api.post('/track/funnel-event') con metadata auto.
import api from './api';

function detectDevice() {
    if (typeof navigator === 'undefined') return 'unknown';
    const ua = navigator.userAgent || '';
    if (/Mobi|Android|iPhone|iPod/i.test(ua)) return 'mobile';
    if (/iPad|Tablet/i.test(ua)) return 'tablet';
    return 'desktop';
}

function detectBrowser() {
    if (typeof navigator === 'undefined') return 'unknown';
    const ua = navigator.userAgent || '';
    if (ua.includes('Edg/')) return 'edge';
    if (ua.includes('OPR/') || ua.includes('Opera')) return 'opera';
    if (ua.includes('Chrome/')) return 'chrome';
    if (ua.includes('Firefox/')) return 'firefox';
    if (ua.includes('Safari/')) return 'safari';
    return 'other';
}

/**
 * Dispara un evento del funnel. Fail-safe: nunca rompe el flujo del usuario.
 * @param {string} stage - etapa del funnel (ver VALID_FUNNEL_STAGES en backend).
 * @param {object} extra - { user_id, last_action, error, time_on_screen_ms, meta }
 */
export async function trackFunnelEvent(stage, extra = {}) {
    try {
        const visitor_id = (typeof window !== 'undefined' && window.localStorage)
            ? localStorage.getItem('visitor_id') || undefined
            : undefined;
        await api.post('/track/funnel-event', {
            stage,
            visitor_id,
            device: detectDevice(),
            browser: detectBrowser(),
            ...extra,
        });
    } catch (_) {
        // intencionalmente silenciado — la telemetría no debe afectar UX
    }
}
